import * as billing from "../../interfaces/screens/billing";
import currencies from "./mock-data/currencies.json";
import invoices from "./mock-data/invoices.json";
import claims from "./mock-data/claims.json";
import patients from "./mock-data/patients.json";
import settings from "./mock-data/settings.json";
import billingCodes from "./mock-data/billing-codes.json";

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const billingService = {
  /**
   * Get list of available currencies
   */
  getCurrencies: async (): Promise<billing.Currency[]> => {
    await delay(500);
    return currencies as billing.Currency[];
  },

  /**
   * Get list of invoices
   */
  getInvoices: async (): Promise<billing.Invoice[]> => {
    await delay(500);
    // This is where we would do the on-the-fly calculations
    return invoices.map((invoice) => ({
      ...invoice,
      // ensure all fields from the interface are present
    })) as billing.Invoice[];
  },

  /**
   * Get list of billing codes
   */
  getBillingCodes: async (): Promise<billing.BillingCode[]> => {
    await delay(500);
    return billingCodes as billing.BillingCode[];
  },

  /**
   * Get list of claims
   */
  getClaims: async (): Promise<billing.Claim[]> => {
    await delay(500);
    return claims as billing.Claim[];
  },

  /**
   * Get list of patients
   */
  getPatients: async (): Promise<any[]> => {
    await delay(500);
    return patients;
  },

  /**
   * Get financial settings
   */
  getFinancialSettings: async (): Promise<any> => {
    await delay(500);
    return settings;
  },
};

export default billingService;
